// extracted by mini-css-extract-plugin
export default {"playerContainer":"styles_playerContainer__-1Ep3","videoPlayer":"styles_videoPlayer__O2sUt"};